import { API_BASE_URL, apiGet, apiPost, apiPut } from '@/api/http';

import type { Seniority } from '@/types/reference';

export const getSeniorityList = () =>
  apiGet<Seniority[]>(`${API_BASE_URL}seniority/`);

export const createSeniority = (name: string) =>
  apiPost<Seniority>(`${API_BASE_URL}seniority/`, { name });

export const setSeniorityList = (seniorityIds: string[]) =>
  apiPut(`${API_BASE_URL}recruiters/me/seniority/`, {
    seniority: seniorityIds,
  });
